var ready = (callback) => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
};

function lazyLoadAds() {
    const options = {
        rootMargin: "0px",
        threshold: 0.5,
    }

    const callback = (entries) => {
        entries.forEach(function (entry) {
            if (madops?.addDynamicAd && entry.isIntersecting) {
                madops?.addDynamicAd(entry.target)
                console.debug("Ad loaded for", entry.target)
                observer.unobserve(entry.target)
            }
        });
    }

    const observer = new IntersectionObserver(callback, options)

    document.querySelectorAll('div[data-m32-dynamic-ad]').forEach(function (ad) {
        observer.observe(ad);
    });
}

ready(() => {
    document.querySelectorAll('.anchor').forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            const element = e.target;

            const href = element.getAttribute('href');
            const id = href?.substr(1);

            document.getElementById(id).scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });

            e.preventDefault();
            return false;
        });
    });

    (function () {
        var pubHeader = document.getElementById("pub-header");
        var pubActive = false;
        var animationDone = true;
        var pubHideDelay = false;
        var timeoutAnimation;
        var timeoutScroll = null;
        var pubType = "";
        //Get the button:
        var tqGoToTop = document.getElementById('btn-top');

        // When the user scrolls down 800px from the top of the document, show the button
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (pubActive) {
                gestionScrollPub();
            }

            if (tqGoToTop) {
                if (document.body.scrollTop > 800 || document.documentElement.scrollTop > 800) {
                    tqGoToTop.style.visibility = 'visible';
                    tqGoToTop.style.opacity = '1';
                } else {
                    tqGoToTop.style.visibility = 'hidden';
                    tqGoToTop.style.opacity = '0';
                }
            }
        }

        lazyLoadAds()

        //gestion du header sticky

        //Verifie si la pub est chargee
        function checkPubActive() {
            checkPubActiveTries++;
            if (pubHeader == null) {
                clearInterval(intervalPubActive);
            } else if (pubHeader.getElementsByTagName('iframe').length > 0) {
                clearInterval(intervalPubActive);
                pubActive = true;
            } else if (checkPubActiveTries >= 10) {
                clearInterval(intervalPubActive);
            }
        }

        //gestion des animations lors du scroll pour eviter les doubles animations
        function gestionScrollPub() {
            clearTimeout(timeoutScroll);
            timeoutScroll = null;
            if (animationDone) {
                if (pubType != "showTop" && document.documentElement.scrollTop <= 10) {
                    window.scrollTo(0, 0);
                    pubType = "showTop";
                    pubHeader.classList.remove("hideWithDelay");
                    pubHeader.classList.remove("hideNoDelay");

                    pubHeader.classList.add("showNoDelay");

                    setAnimationTimeout(200);
                } else if (!pubHideDelay && pubActive && (document.documentElement.scrollTop > 300)) {
                    pubType = "sticky";
                    pubHeader.classList.remove("showNoDelay");
                    pubHideDelay = true;
                    pubHeader.classList.add("hideWithDelay");

                    setAnimationTimeout(3000);
                } else if (pubType == "showTop" && (document.documentElement.scrollTop > 300)) {
                    pubType = "hideTop";
                    pubHeader.classList.remove("showNoDelay");
                    pubHeader.classList.add("hideNoDelay");

                    setAnimationTimeout(200);
                }
            } else {
                timeoutScroll = setTimeout(() => {
                    gestionScrollPub();
                }, 200);
            }
        }

        function setAnimationTimeout(timeOut) {
            animationDone = false;

            timeoutAnimation = setTimeout(() => {
                setAnimationDone();
            }, timeOut);
        }

        function setAnimationDone() {
            clearTimeout(timeoutAnimation);
            animationDone = true;
        }

        var intervalPubActive;
        intervalPubActive = setInterval(checkPubActive, 500);
        var checkPubActiveTries = 0;

    })();
});
